import createReducer from 'utils/createReducer';

// Initial State
const INIT_STATE = {
  uploadDocumentsModalOpened: false,
  shipperOrderId: null,
};

// Actions
const OPEN_UPLOAD_DOCUMENTS_MODAL = 'shipper-order-documents/OPEN_UPLOAD_DOCUMENTS_MODAL';
const CLOSE_UPLOAD_DOCUMENTS_MODAL = 'shipper-order-documents/CLOSE_UPLOAD_DOCUMENTS_MODAL';

// Reducers
export default createReducer(INIT_STATE, {
  [OPEN_UPLOAD_DOCUMENTS_MODAL](state, { shipperOrderId }) {
    return {
      ...state,
      uploadDocumentsModalOpened: true,
      shipperOrderId,
    };
  },
  [CLOSE_UPLOAD_DOCUMENTS_MODAL](state) {
    return {
      ...state,
      uploadDocumentsModalOpened: false,
      shipperOrderId: null,
    };
  },
});

// Action creators
export const openUploadDocumentsModal = ({ shipperOrderId }) => ({
  type: OPEN_UPLOAD_DOCUMENTS_MODAL,
  payload: {
    shipperOrderId,
  },
});

export const closeUploadDocumentsModal = () => ({
  type: CLOSE_UPLOAD_DOCUMENTS_MODAL,
  payload: {},
});
